export const FETCH_DROPDOWNLIST_REQUEST = "FETCH_DROPDOWNLIST_REQUEST";
export const FETCH_DROPDOWNLIST_SUCCESS = "FETCH_DROPDOWNLIST_SUCCESS";
export const FETCH_DROPDOWNLIST_FAILURE = "FETCH_DROPDOWNLIST_FAILURE";
